export default "__VITE_ASSET__Cg4L2dHP__"